// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__7rtXr","menu":"Footer_menu__A40Y+","item":"Footer_item__ddNl5","link":"Footer_link__q5rIu"};